import { ChangeDetectionStrategy, Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { List } from "immutable";
import { ListItem } from "../../../../shared/list/list-item";
import { BulkProjectUploadService } from "../bulk-project-upload/bulk-project-upload.service";

@Component({
  selector: "app-bulk-project-created",
  templateUrl: "./bulk-project-created.component.html",
  styleUrls: ["../bulk-project-upload/bulk-project-upload.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BulkProjectCreatedComponent implements OnInit {
  summaryReport = List<ListItem>();
  private createdProjectIds: number[] = [];

  constructor(
    private readonly bulkProjectUploadService: BulkProjectUploadService,
    private readonly router: Router
  ) { }

  ngOnInit(): void {
    const result = this.bulkProjectUploadService.creationResult.value;

    if (!result) {
      this.router.navigate(["/project/bulkupload"]);
      return;
    }

    this.createdProjectIds = result.createdProjectIds || [];

    const status = result.totalFailed === 0
      ? "PASSED"
      : (result.totalPassed === 0 ? "FAILED" : "PARTIALLY FAILED");

    this.summaryReport = this.summaryReport.push(
      new ListItem({ key: "Total Projects Upload request", value: result.totalRequested.toString(), url: "" }),
      new ListItem({ key: "Total projects Passed", value: result.totalPassed.toString(), url: "" }),
      new ListItem({ key: "Total Projects Failed", value: result.totalFailed.toString(), url: "" }),
      new ListItem({ key: "Validation Status", value: status, url: "" })
    );
  }

  viewProjects(): void {
    // Pass the created ids via navigation state (not query params): a query string on this route trips
    // the route guard and redirects to /403, so the ids are read from history state on the grid page.
    this.router.navigate(["/admin/projects"], {
      state: { projectIds: this.createdProjectIds },
    });
  }

  startNewProjectUpload(): void {
    this.router.navigate(["/project/bulkupload"]);
  }

  trackByIndex(index) {
    return index;
  }
}
